import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  TXTCLI_Your_session_has_expiredX,
  TXTWCL_Your_QR_code_has_expiredX_plea_ELL
} from './PayconiqTimeout.messages.json';

const PayconiqTimeout: React.FC = () => {
  const isPhoneDevice = useSelector(select.device.isPhone);

  return isPhoneDevice ? (
    <Translation {...TXTCLI_Your_session_has_expiredX} />
  ) : (
    <Translation {...TXTWCL_Your_QR_code_has_expiredX_plea_ELL} />
  );
};

export default PayconiqTimeout;
